export var DEPLOY_DATE = new Date('2026-01-08T21:56:56+0000');
